import { render, staticRenderFns } from "./ClienteGet.vue?vue&type=template&id=98d8fe72&scoped=true"
import script from "./ClienteGet.vue?vue&type=script&lang=js"
export * from "./ClienteGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d8fe72",
  null
  
)

export default component.exports